// extracted by mini-css-extract-plugin
module.exports = {"separator":"item_separator-module__separator--28LVN"};